class App {
  static settings = {}
}

export default App;